import { Avatar, Icon, Menu, Overlay } from '@alifd/next';
import { history } from 'ice';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import commonhelper from '@/lib/commonhelper';
import client from '@/lib/feathers';

import styles from './MobileHomeAccount.module.scss';

const { Item } = Menu;
const { Popup } = Overlay;

const MobileHomeAccount = (props) => {
  const userData = useSelector((state) => state.user);

  // console.log('===props', props);
  const [fullscreenStatus, setFullscreenStatus] = useState(false);
  const [popupStatus, setPopupStatus] = useState(false);
  // document.addEventListener("keypress", function(e) {
  //   if (e.keyCode === 13) {
  //     toggleFullScreen();
  //   }
  // }, false);

  function toggleFullScreen() {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setFullscreenStatus(true);
      setPopupStatus(false);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
        setFullscreenStatus(false);
        setPopupStatus(false);
      }
    }
  }
  return (
    <Popup
      className={styles.popup}
      trigger={
        <div className={styles.mobileHeaderAccount}>
          <img
            className={styles.accountImg}
            src={`icon/ic_account.svg`}
            alt="Ic_account icon"
          />
        </div>
      }
      triggerType="click"
      visible={popupStatus}
      onVisibleChange={(visible) => {
        setPopupStatus(visible);
      }}
    >
      <div className={styles.avatarPopup}>
        <div className={styles.profile}>
          <div className={styles.avatar}>
            <Avatar src={props.userImg} alt="用戶頭像" />
          </div>
          <div className={styles.content}>
            <h4>{props.userName}</h4>
            <span>{props.userEmail}</span>
          </div>
        </div>
        {props.hasQRcode === true ? (
          <div
            className={styles.testQR}
            onClick={() => {
              if (commonhelper.isApp()) {
                commonhelper.loadPath('/com');
              } else {
                window.location.href = '/account/#/com';
              }
            }}
          >
            此為測試帳號，尚未開通
          </div>
        ) : null}
        <Menu className={styles.menu}>
          <Item
            onClick={() => {
              history.push('/mobile/setting');
            }}
          >
            <Icon type="account" />
            個人設置
          </Item>
          <Item
            onClick={() => {
              history.push('/mobile/personalNotice');
            }}
          >
            <Icon type="email" />
            個人通知
          </Item>
          <Item
            onClick={() => {
              history.push('/mobile/systemSetting');
            }}
          >
            <Icon type="set" />
            推播設置
          </Item>
          {/* <Item
            onClick={() => {
              if (commonhelper.isApp()) {
                commonhelper.loadPath('/com')
            
              }else{
                window.location.href='/account/#/com';
              }
            }}>
            <Icon  type="add" />
              帳號設置
          </Item> */}
          {!commonhelper.isApp() ? (
            <Item
              onClick={() => {
                toggleFullScreen();
              }}
            >
              <Icon type={fullscreenStatus === false ? 'eye' : 'eye-close'} />
              {fullscreenStatus === false ? '切換全屏' : '關閉全屏'}
            </Item>
          ) : null}

          <Item
            onClick={() => {
              commonhelper.pageReload();
            }}
          >
            <Icon type="refresh" />
            重新整理
          </Item>
          {userData?.auth?.user?.keyboardAccount ? null : (
            <Item
              onClick={async () => {
                if (commonhelper.isApp()) {
                  commonhelper.loadPath('/com');
                } else {
                  await client.logout().catch((err) => {
                    console.log('==logout error:', err);
                    localStorage.removeItem('feathers-jwt');
                  });

                  history.push('/mobile/user/login');
                  commonhelper.pageReload();
                  // window.location.href='/account/#/com';
                }
              }}
            >
              <Icon type="exit" />
              登出
            </Item>
          )}
        </Menu>
      </div>
    </Popup>
  );
};

export default MobileHomeAccount;
